/**
 * Step By Step
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter, getViewportSize } from 'js/helpers.js';
import { scrollToAnchor } from 'js/ra.js';
import { getBreakpointMediaQuery } from 'js/constants.js';
import { openModal, handleModalClose } from '../../../../modal-container/clientlibs/site/js/modal-container.js';
const componentName = 'step-by-step';

export class StepByStep extends Component {

    /**
     * Component Setup
     */

    // Elements
    elements = {
        content: this.element.querySelector(`.${componentName}__content`),
        imageContainer: this.element.querySelector(`.${componentName}__image-container`),
        imageContainerMobile: this.element.querySelector(`.${componentName}__image-container-mobile`),
        mobileTabletContainer: this.element.querySelector(`.${componentName}__image-container-mobile-container`),
        modalBackground: this.element.querySelector(`.${componentName}__image-container-mobile-backdrop`),
        images: this.element.querySelectorAll(`.${componentName}__image-frame`),
        stepTitles: this.element.querySelectorAll(`.${componentName}__step-title`),
        tabletBackground: this.element.querySelector(`.${componentName}__image-tablet-background`)
    };

    state = {
        imageHeight: 0,
        id: this.elements.content.getAttribute('data-id'),
        index: 0
    };

    // [LEGACY BREAKPOINT: max-width 48em -> getBreakpointMediaQuery('down', 'small')]
    matchMobileBp = getBreakpointMediaQuery('down', 'small');

    initDom = () => {
        if (getViewportSize() !== 'mobile' && !this.elements.tabletBackground) {
            this.elements.images.forEach((image) => {
                this.state.imageHeight = (image.scrollHeight > this.state.imageHeight) ? image.scrollHeight : this.state.imageHeight;
            });
            // Set height of image container
            this.elements.imageContainer.style.minHeight = `${this.state.imageHeight}px`;
        }

        this.elements.imageContainerMobile.addEventListener('close', this.handleMobileClose);
        this.elements.modalBackground.addEventListener('click', () => this.elements.imageContainerMobile.close());
        if (this.elements.tabletBackground) {
            this.elements.mobileTabletContainer.addEventListener('click', () => this.elements.imageContainerMobile.close());
            this.elements.imageContainerMobile.querySelector(`.${componentName}__image-tablet-background`).addEventListener('click', (ev) => ev.stopPropagation());
        }

        if (getViewportSize() !== 'mobile') {
            this.elements.images[0].classList.add(`${componentName}__image-frame--active`);
        }

        this.matchMobileBp.addEventListener('change', this.handleMediaChange);

        this.readUrlParams();
    };

    // Handle Mobile Close
    handleMobileClose = () => {
        handleModalClose();
    };

    // Handle Media Change
    handleMediaChange = () => {
        if (getViewportSize() === 'mobile') {
            this.elements.images.forEach((image) => {
                image.classList.remove(`${componentName}__image-frame--active`);
            });
        } else {
            this.elements.imageContainerMobile.close();
            this.elements.images[this.state.index].classList.add(`${componentName}__image-frame--active`);

            if (!this.elements.tabletBackground) {
                this.elements.images.forEach((image) => {
                    this.state.imageHeight = (image.scrollHeight > this.state.imageHeight) ? image.scrollHeight : this.state.imageHeight;
                });
                // Set height of image container
                this.elements.imageContainer.style.minHeight = `${this.state.imageHeight}px`;
            }
        }
    };

    // Read URL Params
    readUrlParams = () => {
        // Check for anchor tag in URL and update state
        const url = window.location.href;
        const anchor = url.split('#')[1];
        if (anchor && anchor.includes(this.state.id) && anchor.split('i=')[1]) {
            if (getViewportSize() !== 'mobile') {
                this.updateActiveImage(parseInt(anchor.split('i=')[1], 10));
            }
            if (document.readyState === 'complete') {
                scrollToAnchor(this.element);
            } else {
                window.addEventListener('load', () => {
                    scrollToAnchor(this.element);
                });
            }
        }
    };

    // Update active image
    updateActiveImage = (indexIn) => {
        if (indexIn === this.state.index && getViewportSize() !== 'mobile') return;
        // Update state
        if (this.elements.imageContainer.querySelector(`.${componentName}__image-frame--active`)) {
            this.elements.imageContainer.querySelector(`.${componentName}__image-frame--active`).classList.remove(`${componentName}__image-frame--active`);
        }
        this.elements.images[indexIn].classList.add(`${componentName}__image-frame--active`);
        this.state.index = indexIn;

        if (getViewportSize() === 'mobile') {
            this.elements.imageContainerMobile.querySelector(`.${componentName}__image-container-mobile-content`).innerHTML = this.elements.images[indexIn].outerHTML;
            openModal(this.elements.imageContainerMobile);
        }
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.stepTitles.forEach((stepTitle, index) => {
            stepTitle.addEventListener('click', () => {
                this.updateActiveImage(index);
            });
            stepTitle.addEventListener('keydown', (e) => {
                e.stopPropagation();
                // Enter key
                if (e.keyCode === 13) {
                    this.updateActiveImage(index);
                }
            });
            stepTitle.addEventListener('mouseenter', () => {
                if (getViewportSize() !== 'mobile') {
                    stepTitle.click();
                }
            });
        });
    };

    /**
     * Initialize Component
     */
    init() {
        // Fire Init Funcs
        if(!isEditModeFooter()) {
            this.initDom();
            this.addEventListeners();
        }
    }
}

registerComponent(`.${componentName}`, StepByStep);
